import crud from './_crud'
import { callApi } from 'utils/api'
import { showErrorMessage, showSuccessMessage } from 'utils/messages'

const actions = crud(
	'type_of_id',
	'Tipo de ID',
	'Tipos de ID'
)

export default { ...actions, }
